import {
  FULFILLMENT_STATUSES,
  ORDER_METHODS,
  PaymentMethods,
  REFUND_REASONS,
} from '../../../../../services/exports/Constants';
import { OFFER_KIND } from '../../../../../views/menu/offers/constants';

export default {
  title: 'Ordredetaljer',
  sections: {
    driver_info: 'Chaufførinfo',
    order_info: 'Ordreinfo',
    price_info: 'Prisinfo',
    adjustments: 'Justeringer',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Takeaway',
    [ORDER_METHODS.delivery]: 'Levering',
    [ORDER_METHODS.on_site]: 'Bordbestilling',
  },
  fulfillment_statuses: {
    [FULFILLMENT_STATUSES.created]: 'Denne ordre afventer godkendelse',
    [FULFILLMENT_STATUSES.reviewed]: 'Denne ordre afventer godkendelse',
    [FULFILLMENT_STATUSES.accepted]: 'Denne ordre behandles i øjeblikket',
    [FULFILLMENT_STATUSES.preparing]: 'Denne ordre behandles i øjeblikket',
    [FULFILLMENT_STATUSES.ready]: 'Denne ordre er klar til afhentning af kunden',
    [FULFILLMENT_STATUSES.on_delivery]: 'Denne ordre er på vej til kunden',
    [FULFILLMENT_STATUSES.picked]: 'Denne ordre er gennemført',
    [FULFILLMENT_STATUSES.rejected]: 'Denne ordre er afvist og refunderet',
    default: 'Denne ordre er gennemført',
  },
  adjustment_reasons: {
    [REFUND_REASONS.RequestedByCustomer]: 'Anmodet af kunden',
    [REFUND_REASONS.Reclamation]: 'Reklamation',
    [REFUND_REASONS.CommunicationError]: 'Kommunikationsfejl',
    [REFUND_REASONS.Other]: 'Andet',
    [REFUND_REASONS.Dispute]: 'Kundetvist',
    dispute_win: 'Vundet kundetvist',
    null: '',
    undefined: '',
  },
  labels: {
    // A table order's table: "Table 7"; names like "Terrace 2" show as they are.
    table_numbered: 'Bord {{name}}',
    // Orders placed with Room/Table service before table ordering: the venue and the number typed.
    venue: 'Sted',
    table_number: 'Bordnummer',
    order_note: 'Ordrenote',
    discount: 'Rabat',
    driver_name: 'Chaufførens navn',
    driver_phone_number: 'Chaufførens telefon',
    pin_code: 'PIN',
    invoice_payment: 'Betaling via faktura',
    paid_in_cash: 'Betaling med kontanter',
    customer_paid_online: 'Kunden betalte online',
    phone: 'Tlf.',
    email: 'E-mail',
    points_used: 'Denne ordre indeholder en loyalitetspoint-belønning, som en loyal kunde har indløst',
    delivery: 'Levering',
    pickup: 'Afhentning',
    original: 'Original',
    delivery_fee: 'Leveringsgebyr',
    tip: 'Drikkepenge',
    service_fee: 'Onlinebehandling',
    payment_method_upcharge_fee: {
      [PaymentMethods.PAYPAL]: 'PayPal-gebyr',
    },
    discount_breakdown: {
      [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Procentrabat på total anvendt',
      [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Procentrabat på produkter anvendt',
      [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Beløbsrabat på produkter anvendt',
      [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Beløbsrabat på total anvendt',
      [OFFER_KIND.BOGO]: 'Bogo anvendt',
      [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo halv pris anvendt',
      [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Gratis vare på produkter anvendt',
      [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Gratis vare på total anvendt',
      GiftCard: 'Gavekort anvendt',
      Reward: 'Loyalitetspoint anvendt',
      CashbackAccount: 'Loyalitetspoint anvendt',
      PromoCodeComponent: 'Kampagne anvendt',
      Offer: 'Tilbud anvendt',
    },
    total_discount: 'Kampagne anvendt',
    tax: 'Moms',
    total: 'I alt',
    today: 'I dag',
  },
  schedule: {
    header: 'Planlagt til {{date}}, {{time}}',
    text: 'Vi minder dig om, når det er tid til at begynde at tilberede ordren',
  },
};
